import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@shs-digi-care-monorepo/frontend-lib/environments';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Import SHUI web components to register them as custom elements
import '@shui/core/sh-breadcrumbs';
import '@shui/core/sh-button';
import '@shui/core/sh-card';
import '@shui/core/sh-search';
import '@shui/core/sh-badge';
import '@shui/core/sh-icon';
import '@shui/core/sh-popover';
import '@shui/core/sh-checkbox';
import '@shui/core/sh-menu-item';
import '@shui/core/sh-input-text';
import '@shui/core/sh-toggle';
import '@shui/core/sh-dropdown';
import '@shui/core/sh-tooltip';
import '@shui/core/sh-user-identifier';
import '@shui/core/sh-text';
import '@shui/core/sh-table';
import '@shui/core/sh-empty-state';
import '@shui/core/sh-tabs';
import '@shui/core/sh-pagination';
import '@shui/core/sh-spinner';
import '@shui/core/sh-progress';
import '@shui/core/sh-snackbar';
import '@shui/core/sh-switch';
import '@shui/core/sh-datepicker';
import '@shui/core/sh-stepper';
import '@shui/core/sh-tag';
import '@shui/core/sh-divider';
import '@shui/core/sh-ai-tag';
import '@shui/core/sh-alert';
import '@shui/core/sh-vertical-nav';

// Enable production mode if needed
if (environment.production) {
    enableProdMode();
}

// Bootstrap the Angular application
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
